<template>
  <v-list>
    <v-list-item v-for="wbType in wbTypes" :key="wbType" ripple>
      <v-list-item-content class="cursor-pointer" @click="$emit('click', wbType)">
        {{ $t(`module.wagenbuch.type.${wbType}.create`) }}
      </v-list-item-content>
    </v-list-item>
    <v-divider v-if="ereignisse.length > 0"></v-divider>
    <v-list-item ripple v-for="(ereignis, index) in ereignisse" :key="'s-form-' + index">
      <v-list-item-content class="cursor-pointer" @click="$emit('click', ereignis.name)">
        {{ ereignis.name }}
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import index from './index';
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';

export default {
  mixins: [common, configMixin],
  computed: {
    ...mapState('wagenbuch', ['ereignisse']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance);
    },
    wbTypes() {
      return this.moduleConfig.types ? this.moduleConfig.types.split(',') : ['mangel'];
    },
  },
};
</script>
